import axios from "axios";
import { API_BASE_URL } from "../../utils/constants";

const createClient = () =>
  axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Accept: "application/json",
    },
  });

const API = createClient();
const APIAuthenticated = createClient();

APIAuthenticated.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { API, APIAuthenticated };
